import { render } from "./Chat.vue?vue&type=template&id=79dc5122"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=79dc5122&lang=stylus"
script.render = render

export default script